export default __webpack_public_path__ + "static/firstview-pc-241fd9f89adbf3b534709023a89eef62.jpg";